module.exports = __webpack_public_path__ + "banquet/components/images/chevron_black.c85473623b08b1beb7103cb14d23283f.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/chevron_black.png
// module id = 1700
// module chunks = 1